import { useNuxtApp } from '#app';
import { useActiveFocus } from './useActiveFocus';

let isInitialized = false;

/**
 * Composable to handle keyboard focus management for the Ask Macy's chat drawer.
 * Natively captures the active triggering element upon drawer open,
 * and restores focus to that element upon drawer close.
 */
export const useAskAIFocus = () => {
  if (isInitialized) {
    return;
  }
  isInitialized = true;
  const nuxtApp = useNuxtApp();
  const { activeEl, setActiveElement } = useActiveFocus();

  nuxtApp.hook('ask-ai:google-agent-open-changed', (detail) => {
    if (detail.isOpen) {
      // Capture the triggering element if not already manually set
      if (!activeEl.value) {
        const active = document.activeElement;
        if (active && active !== document.body) {
          setActiveElement(active as HTMLElement);
        } else {
          // Fallback to explicit ID if a third-party script already moved focus
          setActiveElement(document.querySelector('#ask-ai-gecx-button') as HTMLElement);
        }
      }

      // Note: Moving focus INTO the drawer is controlled by the Google Agent script itself.
      // We only track the trigger element here to restore focus upon drawer close.
    } else if (activeEl.value) {
      // Restore focus back to the triggering element on close
      activeEl.value.focus();
      setActiveElement(null);
    }
  });
};
